import UtilityNavLink from './utility-nav-link'

export default UtilityNavLink
